import {
  IntegrationHealthCheckResponse,
  NangoConnectionTokenResponse,
  OAuthConfigurationResponse,
  ResultResponse,
} from '@electricjs/core_entity-client';

import { ApplicationSlug } from '@/constants/applications';

export const healthyIntegrationResponse: IntegrationHealthCheckResponse = {
  result: ResultResponse.Success,
};

export const nangoConnectionTokenResponse: NangoConnectionTokenResponse = {
  token: 'mock-nango-connection-token',
  expires_at: '2099-01-01T00:00:00.000Z',
};

export const supportedProfileFields = [
  'first_name',
  'last_name',
  'job_title',
  'department',
];

// Mirrors core-entity's MicrosoftIntegration.updateable_profile_fields() with
// the extended-fields, manager and preferred-name flags on (includes keys the
// UI had no translation for: employment_type, business_unit).
const microsoftSupportedProfileFields = [
  'address',
  'business_unit',
  'employment_type',
  'first_name',
  'home_department',
  'job_title',
  'last_name',
  'manager',
  'personal_email',
  'phone_number',
  'preferred_first_name',
  'work_email',
  'work_location',
];

export const supportedProfileFieldsByApplication: Record<string, string[]> = {
  [ApplicationSlug.MicrosoftEntraId]: microsoftSupportedProfileFields,
};

export const createOAuthConfigurationResponse = (
  organizationApplicationId: string
): OAuthConfigurationResponse => ({
  id: `oauth-config-${organizationApplicationId}`,
  organization_application_id: organizationApplicationId,
  created_at: '2024-01-01T00:00:00.000Z',
  updated_at: '2024-01-01T00:00:00.000Z',
});
